module.exports = __webpack_public_path__ + "img/theme2.7de91bce.png";